<template>
    <div class="home">
        <headers ref="headers" :active-index="index"></headers>
        <contents ref="contents" @homeHotProductClickInfo="homeHotProductClickInfoClick" @homeFindMoreClick="contentFindMoreClick"  @homefindCompanyInfo="contentFindCompanyInfo"></contents>
        <footers></footers>
    </div>
</template>
<script>
    /* eslint-disable */
    import headers from '@/components/header.vue';
    import contents from '@/components/content.vue';
    import footers from '@/components/footer.vue';

    export default {
        components: {headers, contents, footers},
        data() {
            return {
                barType: 1,
                menuObj: {},
                urls: '',
                title: '',
                index:0
            }
        },
        provide() {
            return {
                parentEle: this
            }
        },
        watch: {},
        mounted() {

        },
        computed: {},
        methods: {
          contentFindMoreClick(){
              this.$refs.headers.menuClickList(2)
          },
          contentFindCompanyInfo(){
              //查看公司详情
              this.$refs.headers.menuClickList(1)
          },
          homeHotProductClickInfoClick(){
              //查看热门产品
              this.$refs.headers.menuClickList(4);
          }
        }
    }
</script>
<style lang="less" scoped>
    .home {
        width: 100%;
        height: 100%;
        background: #fff;

        .contents {
            min-height: calc(~"100% - 190px");
        }
    }

</style>